import './style.css';
interface LedProps {
  color: 'green' | 'yellow' | 'red' | 'blue';
  animation?: boolean;
  off?: boolean;
}

export default function Led({
  color,
  animation = false,
  off = false,
}: LedProps) {
  return (
    <div
      className={
        off
          ? `led-${color}-off`
          : animation
            ? `led-${color}-animated`
            : `led-${color}`
      }
    ></div>
  );
}
